import "./SelectOptionSingle.scss";

import React from "react";
import { ErrorMessage, Field } from "formik";

const SelectOptionSingle = ({ label, name, options }) => {
  return (
    <div className="select-option-single">
        <label
          className="paragraph-gray-reg-14 select-option__label"
          htmlFor={`${name}`}
        >
          {label}
        </label>
        <Field as="select" name={`${name}`} className="select-option__input">
          {options?.map((loc, i) => (
            <option key={i} value={loc.value}>
              {loc.label}
            </option>
          ))}
        </Field>
      <div className="select-option__error">
        <ErrorMessage name={`${name}`} />
      </div>
    </div>
  );
};

export default SelectOptionSingle;
